module.exports = {"headerColumns":{"invoiceNumber":"Factuurnr.","checkinDatetime":"Check-in","checkoutDatetime":"Check-out","description":"Beschrijving","brutoAmount":"Ritprijs*"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/trip.json
// module id = aBqe
// module chunks = 1